import React from 'react';
import { withRouter, Link } from 'react-router-dom';
import MetaTags from '../molecules/MetaTags';
import MyAvatarsHolder from '../organisms/MyAvatarsHolder';
import { sharing } from '../data/sharing';


function MyAvatars({location}) {
  const shareURL = `${sharing.home.ogUrl}${location.pathname}${location.search}`;

  return (
    <>
      <MetaTags
        shareURL = {shareURL}
        shareDesc = {sharing.myAvatars.ogDesc}
        shareImage = {sharing.myAvatars.ogImage}
      />

      <h1>Hello!</h1>
      <p><strong className="highlight-yellow">View the avatars your friend created below and learn about machine learning labeling bias.</strong></p>
      <p>Take the exercise and learn why it’s important to have diverse people, diverse and consistent labels and diverse images training AI.</p>

      <MyAvatarsHolder />

      <h5 className="again">Want to try the exercise?</h5>
      <Link className="button primary" to="/">Start here</Link>
    </>
  )
}

export default withRouter( MyAvatars );
